<div class="notification-container">
  <div class="page-title-block common-head">
    <div class="title-block-left">
    <h1 class="title h2">Notifications</h1>
  </div>
  </div>
  <!-- when we click on team , team,client,engagement need to be shown -->
  <div class="content-block-main d-flex flex-column gap-32" id="notification">
    <!-- Team -->
    <div class="card form-view-only" *ngFor="let otherStatus of otherNotificatinons" [id]="otherStatus.submodulename">
      <div class="card-header"><h4 class="title">{{otherStatus.submodulename}}</h4></div>
      <div class="card-body">

          <mat-list role="list" class="mat-list-base templates-list-items level-one">
            <mat-list-item class="mat-list-item" >
              <div class="d-flex flex-row justify-content-between list-item-content">
                <h5>Notify me when:</h5>
                <i class="fa-regular fa-bell-ring"></i>
              </div>
            </mat-list-item>
            <mat-list-item class="mat-list-item" *ngFor="let otherChild of otherStatus.childs">
              <div class="d-flex flex-row justify-content-between list-item-content">
          <div class="cust-fontweight">
            <span>{{otherChild.notificationname}}</span>
          </div>
          <div class="flex-box-col flex-box mar-r-21">
            <mat-panel-description class="m-0 flex-grow-0">
              <mat-slide-toggle class="toggle-slide-slider"
                                [checked]="otherChild.isnotify === 0 ? 'false' : 'true'"
                                (change)="slideToggleChanged($event, otherChild)">
              </mat-slide-toggle>
            </mat-panel-description>
            <!-- <div class="borderleft flex-box">
            <mat-checkbox class="custom-checkbox"></mat-checkbox>
          </div> -->
          </div>
        </div>
      </mat-list-item>
          </mat-list>
    </div>
    </div>

    <!-- Engagements -->
    <div class="card form-view-only template-block-main">
      <div class="card-header w-100" id="Engagements">
        <h4>Engagements</h4>
        <div>
          <button mat-button class="button-medium-icon button-tooltip" title="Expand" *ngIf="expand" (click)="accordion.closeAll(); expand=false">
            <i class="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center"></i>
          </button>
          <ng-container>
            <button mat-button class="button-medium-icon button-tooltip" title="Collapse" *ngIf="!expand" (click)="accordion.openAll(); expand=true">
              <i class="fa-regular fa-arrow-down-left-and-arrow-up-right-to-center"></i>
            </button>
          </ng-container>
        </div>
      </div>
      <div class="card-body w-100">
      <mat-accordion class="d-flex flex-column gap-32"  multi *ngFor="let status of engagementNotificatinons;trackBy: trackByfirstRecords;">
        <mat-expansion-panel  *ngFor="let section of status.section;trackBy: trackByRecords;">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="title-content">
              <span class="item-title">{{section.notename}} </span>
              <span class="togglable-icon">
                  <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
              </span>
          </span>
        </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-list role="list" class="mat-list templates-list-items pt-4">
            <mat-list-item class="mat-list-item w-100" >
              <div class="d-flex flex-row justify-content-between list-item-content">
                <h5>Notify me when:</h5>
                <i class="fa-regular fa-bell-ring"></i>
              </div>
            </mat-list-item>
            <mat-list-item class="mat-list-item w-100" *ngFor="let child of section.child">
              <div class="d-flex flex-row justify-content-between list-item-content">
                <span class="cust-fontweight">{{child.notificationname}}</span>

                <mat-panel-description class="m-0 flex-grow-0">
                  <mat-slide-toggle class="toggle-slide-slider"
                                    [checked]="child.isnotify === 0 ? 'false' : 'true'" (change)="slideToggleChanged($event, child)">
                  </mat-slide-toggle>
                </mat-panel-description>
                <!-- <div class="borderleft flex-box">
                <mat-checkbox class="custom-checkbox"></mat-checkbox>
              </div> -->
              </div>
            </mat-list-item>

          </mat-list>
          <!--------Schedule time---------->
          <form [formGroup]="scheduleForm" autocomplete="off">
            <div class="Schedule-time" *ngIf="section.noteid == 5 && loggedInUserData.useraccesstypeid == 2">
              <div class="flex-box-left notify-me">
                <h5>Schedule batch document requests daily at:</h5>
              </div>
              <div class="schedule-date">
                <ng-select class="map-head-dropdown firm-input-field" placeholder="Time" [items]="getScheduleData"
                           bindLabel="time" bindValue="time" [selectOnTab]="true" [virtualScroll]="true"
                           [clearable]="false" formControlName="scheduleTime"
                           (change)="onScheduleTime($event, '1')">
                </ng-select>
              </div>
            </div>
            <div class="Schedule-time" *ngIf="section.noteid == 5 && loggedInUserData.useraccesstypeid == 2">
              <div class="flex-box-left notify-me">
                <h5>Remind for document requests sent at:</h5>
              </div>
              <div class="schedule-date">
                <ng-select class="map-head-dropdown firm-input-field" placeholder="Time" [items]="getScheduleData"
                           bindLabel="time" bindValue="time" [selectOnTab]="true" [virtualScroll]="true"
                           [clearable]="false" formControlName="reminderTime"
                           (change)="onScheduleTime($event, '2')">
                </ng-select>
              </div>
            </div>
          </form>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    </div>
    <!--Time Tracker-->
    <ng-container *ngIf="ttNotifications && ttNotifications.length > 0 && !isTrackerOn">
    <div class="card form-view-only"  id="TimeTracking" *ngFor="let tt of ttNotifications">
      <div class="card-header"><h4>{{tt.submodulename}}</h4></div>
      <div class="card-body">

          <mat-list role="list" class="mat-list-base templates-list-items level-one">
            <mat-list-item class="mat-list-item" >
              <div class="d-flex flex-row justify-content-between list-item-content">
                <h5>Everyone assigned to an engagement gets notified when:</h5>
                <i class="fa-regular fa-bell-ring"></i>
              </div>
            </mat-list-item>
            <mat-list-item class="mat-list-item" *ngFor="let ttChild of tt.childs">
              <div class="d-flex flex-row justify-content-between list-item-content">


            <h6>{{ttChild.notificationname}}</h6>

            <mat-panel-description class="m-0 flex-grow-0">
              <mat-slide-toggle class="toggle-slide-slider"  [checked]="ttChild.isnotify === 0 ? 'false' : 'true'" (change)="slideToggleChanged($event, ttChild)">
              </mat-slide-toggle>
            </mat-panel-description>

          </div>
        </mat-list-item>
      </mat-list>
    </div>
    </div>
  </ng-container>
  </div>
</div>
